<template>
  <div>
    <div class="row py-3 px-md-0 px-1 mb-3 mx-md-0 mx-1 success">
      <div class="col-md-1 col-2 text-center center-icon">
        <i class="far"
           :class="icon ? icon : ''"></i>
      </div>
      <div class="col">
        <div class="row">
          <div class="header break-full">
            <strong class="pr-1">{{ title }}</strong> <em v-if="estTime" >(Zeitaufwand: ungefähr {{ estTime }})</em>
          </div>
        </div>
        <div class="row pr-md-0 pr-4">
          {{ content}}
        </div>
        <div class="row pr-md-0 pr-4 break-full" v-if="actionUrl && actionText">
          <span class="pr-1"> {{ actionInfo }}</span> <a class="text-info" :href="actionUrl"> {{ actionText}}</a>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
export default {
  name: 'Success',
  props: [
    'title',
    'estTime',
    'content',
    'icon',
    'actionText',
    'actionUrl',
    'actionInfo'
  ]

}
</script>
<style>
.center-icon {
  align-self: center;
}
.success {
  background-color: rgba(0, 152, 35, 0.41);
  border-radius: 5px
}

.break-full {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
</style>
